// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { lisk as _lisk } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the lisk chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1135
 * Chain Name: Lisk
 * Default Block Explorer: https://blockscout.lisk.com
 * Default RPC URL: https://rpc.api.lisk.com
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { lisk } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: lisk,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const lisk = createCommon({
	..._lisk,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
